import Image from 'next/image';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import MillesimaLink from '@/components/common/MillesimaLink';
import { URLS } from '@/constants/urls';

const FooterSocialLinks = ({ conf: { facebook, instagram, twitter, youtube } }) => {
	const socialsLinks = useMemo(
		() => [
			{
				icon: URLS.FACEBOOK_ICON,
				href: facebook,
				name: 'facebook',
			},
			{
				icon: URLS.INSTAGRAM_ICON,
				href: instagram,
				name: 'instagram',
			},
			{
				icon: URLS.TWITTER_ICON,
				href: twitter,
				name: 'twitter',
			},
			{
				icon: URLS.YOUTUBE_ICON,
				href: youtube,
				name: 'youtube',
			},
		],
		[facebook, instagram, twitter, youtube],
	);

	return (
		<ul className="list-inline d-flex">
			{socialsLinks.map(({ href, name, icon }) => (
				<li key={name} className="list-inline-item">
					<MillesimaLink customClassName={{ container: 'mr-2' }} href={href} ariaLabel={name} isNofollow>
						<Image src={icon} height={16} width={16} alt={name} loading="lazy" />
					</MillesimaLink>
				</li>
			))}
		</ul>
	);
};
FooterSocialLinks.propTypes = {
	conf: PropTypes.shape({
		facebook: PropTypes.string,
		instagram: PropTypes.string,
		twitter: PropTypes.string,
		youtube: PropTypes.string,
	}).isRequired,
};

export default FooterSocialLinks;
